import { Wallet } from 'lucide-react'

export default {
	icon: Wallet,
	name: 'Wallet',
	onClick: ({ router, onClose }: any) => {
		router.push('/wallet')
		onClose()
	},
	featured: true,
	filter: ({ loggedIn }: any) => {
		return loggedIn
	}
}
